import { render, staticRenderFns } from "./AppealTag.vue?vue&type=template&id=14cb90b2&scoped=true&"
import script from "./AppealTag.vue?vue&type=script&lang=js&"
export * from "./AppealTag.vue?vue&type=script&lang=js&"
import style0 from "./AppealTag.vue?vue&type=style&index=0&id=14cb90b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cb90b2",
  null
  
)

component.options.__file = "AppealTag.vue"
export default component.exports